module.exports = __webpack_public_path__ + "img/no-record.60c90f94.png";